import React, { Component } from 'react';
import { Nav, NavDropdown, Navbar, Button } from 'react-bootstrap';


class menu_clientes extends Component {
  constructor(props) {
    const tipo = sessionStorage.getItem('tipo');
    const nombre_empresa = sessionStorage.getItem('nombre');
    const nombre_usuario = sessionStorage.getItem('usuario');
    super(props);
    this.state = {
      currentCompanyName: nombre_empresa,
      currentUserName: nombre_usuario,
      tipo
    }
  }

  
  render() {
    //const validarTipo = (this.state.currrentType === '0' || this.state.currrentType === '1')
    //const rutaEmpresa = (this.state.currrentType === '0') ? '/empresa' : '/empresa/crear/?' + this.state.currentCompany;
    //const { ped } = this.state;
    //const { currentCompany } = this.state;
    return (
      <div style={{ 'fontSize': 12 }}>
        <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
          <Navbar.Brand href="/home"><img src="/logopage.png" alt="IngenIA 365" height="40px" width="150px"></img></Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">

          <NavDropdown title="Estructuracion" id="collasible-nav-dropdown">
                    <NavDropdown.Item href="/formularioCustomer">Cliente</NavDropdown.Item>
                  </NavDropdown>
                    
              <Nav className="mr-auto" >
                <Navbar bg="light" expand="lg">
                  <Nav className="mr-auto">
                     <NavDropdown title="Pedidos" id="collasible-nav-dropdown" className="ml-3">
                    <NavDropdown.Item href="/pedidosCust">Crear Pedido</NavDropdown.Item>
                    <NavDropdown.Item href="/reportepedidosCust">Reporte de pedidos</NavDropdown.Item>
                    </NavDropdown>
                  </Nav>
                </Navbar>
                {/* <Nav.Link href="/reportes">Reportes</Nav.Link> */}
              </Nav>

            <Nav>
              <Navbar.Brand><h6>{this.state.currentUserName}</h6></Navbar.Brand>
              <Navbar.Brand><h6>{this.state.currentCompanyName}</h6></Navbar.Brand>

              <Button href="/cerrarsesion" variant="outline-secondary">Cerrar Sesion</Button>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>);
  }
}
export default (menu_clientes);